"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, LayoutGrid } from "lucide-react";
import { cn } from "@/lib/utils";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import type { MegaMenuConfig } from "@/lib/navigation";
interface MegaMenuBottomStripProps {
  strip: NonNullable<MegaMenuConfig["bottomStrip"]>;
  /** Dropdowns stack the links; the full-width shelf lines them up. */
  stacked: boolean;
  onClose: () => void;
}

/** The menu's footer: its hub (grid icon, green), then further links (arrow). */
export function MegaMenuBottomStrip(t0) {
  const $ = _c(14);
  const {
    strip,
    stacked,
    onClose
  } = t0;
  const t1 = stacked ? "flex-col items-start gap-2.5 px-[26px] py-3.5" : "max-w-[1280px] mx-auto px-20 py-4 items-center gap-8";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex text-sm font-bold", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LayoutGrid className="w-4 h-4" aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClose || $[4] !== strip.primary.href || $[5] !== strip.primary.label) {
    t4 = <LandvestHandoffLink href={strip.primary.href} onClick={onClose} className="flex items-center gap-2 text-secondary hover:text-primary transition-colors">{t3}{strip.primary.label}</LandvestHandoffLink>;
    $[3] = onClose;
    $[4] = strip.primary.href;
    $[5] = strip.primary.label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose || $[8] !== strip.links) {
    t5 = strip.links?.map(link => <LandvestHandoffLink key={link.href} href={link.href} onClick={onClose} className="group flex items-center gap-1.5 text-primary hover:text-secondary transition-colors">{link.label}<ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" /></LandvestHandoffLink>);
    $[7] = onClose;
    $[8] = strip.links;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="bg-primary/5 border-t border-primary/[0.08]"><div className={t2}>{t4}{t5}</div></div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}